export const contentTableConfig = {
  title: '明细列表',
  propList: [
    {prop: 'empName', label: '员工名称', minWidth: '60'},
    {prop: 'empTagStr', label: '员工标签', minWidth: '60'},
    {prop: 'deptName', label: '所属部门', minWidth: '60'},
    {prop: 'point', label: '获取积分', minWidth: '60'},
    {prop: 'createdTime', label: '获取时间', minWidth: '80', sortable: 'createdTime'},
    {prop: 'useStatus', label: '使用状态', minWidth: '60', slotName: 'useStatus'},
    {prop: 'remark', label: '备注', minWidth: '120', align: 'left'},
    {prop: 'playName', label: '活动名称', minWidth: '80'},
    {prop: 'winAmount', label: '中奖金额', minWidth: '80', sortable: 'winAmount'},
    {prop: 'useTime', label: '中奖时间', minWidth: '80', sortable: 'useTime'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
